import React, { useContext, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { AppContext } from '@prisjakt/ui-app-context';
import { Product, TrendingProduct } from 'src/types';
import { ProductsSection } from 'src/components/products-section';
import { TRENDING_PRODUCT_CLICK } from 'src/globals/helpers/navigation-action';
import {
  InternalNavigationScope,
  trackInternalNavigationClick,
} from 'src/globals/tracking/tracking';
import { productNavigation } from '../../actions/product';

type Props = {
  trendingProducts?: Product['trendingProducts'];
};

export const TrendingProducts: React.FC<Props> = ({ trendingProducts }) => {
  const { t } = useContext(AppContext);
  const dispatch = useDispatch();

  const mappedProducts: Product[] | null = useMemo(() => {
    if (!trendingProducts) {
      return null;
    }
    return trendingProducts
      .filter((tp): tp is TrendingProduct => Boolean(tp))
      .filter((tp: TrendingProduct) => Boolean(tp.pathName))
      .map(product => ({
        id: Number(product.id),
        name: String(product.name),
        pathName: product.pathName ?? '',
        media: { first: product.imageUrl, count: 1 },
        priceSummary: { regular: product.price },
        classicFullPath: String(product.url),
        userReviewSummary: {
          rating: product.userReviewRating,
          count: product.userReviewCount,
        },
        conditions: [] as Product['conditions'],
      }));
  }, [trendingProducts]);

  if (!mappedProducts || mappedProducts.length === 0) {
    return null;
  }

  return (
    <ProductsSection
      negativeMargin
      products={mappedProducts}
      title={t('landing', 'trending-products.title')}
      onProductCardClick={({ index, link }) => {
        dispatch(productNavigation(TRENDING_PRODUCT_CLICK, index + 1));
        trackInternalNavigationClick({
          scope: InternalNavigationScope.TRENDING_PRODUCTS_PRODUCT_CARD,
          nextPage: link,
          index,
        });
      }}
    />
  );
};
